/* eslint-disable @typescript-eslint/no-unsafe-return */
import FormControl from '@material-ui/core/FormControl'
import { makeStyles } from '@material-ui/core/styles'
import TextField, { TextFieldProps } from '@material-ui/core/TextField'
import { isFunction } from 'lodash'
import React from 'react'
import { WidgetProps } from 'react-jsonschema-form'

const useStyles = makeStyles(theme => ({
  input: {
    fontSize: 20,
    fontWeight: 'bold',
  },
  label: {
    color: theme.palette.grey['800'],
    fontWeight: 'bold',
  },
}))

export type TextWidgetProps = Omit<WidgetProps, 'options'> & {
  options?: {
    emptyValue?: string
    inputType?: TextFieldProps['type']
  }
}

const TextWidget = ({
  id,
  required,
  readonly,
  disabled,
  label,
  value,
  onChange,
  onBlur,
  onFocus,
  autofocus,
  options: { emptyValue = '', inputType = 'text' } = {},
  schema,
}: TextWidgetProps) => {
  const handleChange = ({ target: { value: targetValue } }: React.ChangeEvent<HTMLInputElement>) =>
    isFunction(onChange) && onChange(targetValue === '' ? emptyValue : targetValue)
  const handleBlur = ({ target: { value: targetValue } }: React.FocusEvent<HTMLInputElement>) =>
    isFunction(onBlur) && onBlur(id, targetValue)
  const handleFocus = ({ target: { value: targetValue } }: React.FocusEvent<HTMLInputElement>) =>
    isFunction(onFocus) && onFocus(id, targetValue)

  const classes = useStyles()

  return (
    <FormControl fullWidth required={required}>
      <TextField
        InputLabelProps={{ className: classes.label }}
        autoFocus={autofocus}
        color="secondary"
        disabled={disabled || readonly}
        id={id}
        inputProps={{ className: classes.input }}
        label={label || schema.title}
        margin="normal"
        required={required}
        type={inputType}
        value={(value || '') as string}
        onBlur={handleBlur}
        onChange={handleChange}
        onFocus={handleFocus}
      />
    </FormControl>
  )
}

export default TextWidget
